export default __webpack_public_path__ + "static/media/heart-broken-line.c49a84ac.svg";